import actions from '../actions/dashboard';
export const collectionAndDeliveryDelay = async (data) => {
  return actions.collectionAndDeliveryDelay(data);
};
export const getCollectionAndDeliveryDelayByReportType = async (config) => {
  return actions.getCollectionAndDeliveryDelayByReportType(config);
};

export const reportsGenerate = async (payload) => {
  return actions.reportsGenerate(payload);
}
export const metricDefinitions = async (payload, type) => {
  return actions.metricDefinitions(payload, type);
}
export const getKpiReports = async (payload, path, selectedDate) => {
  return actions.getKpiReports(payload, path, selectedDate);
}
export const getReports = async (payload, selectedDate) => {
  return actions.getReports(payload, selectedDate);
}

